import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store/'
import * as types from '../store/action-types'
// import axios from 'axios'
Vue.use(VueResource)

// Vue.http.options.root = 'http://localhost'
Vue.http.headers.common['Accept'] = 'application/json'
Vue.http.headers.common['Content-Type'] = 'application/json'
Vue.http.headers.common['Content-Type'] = 'application/json'

Vue.http.options.emulateJSON = true

// API Request Interceptor
Vue.http.interceptors.push((request, next) => {
// continue to next interceptor
  if (store.state.userStore.token !== null) {
    // console.log(store.state.userStore.token)
    Vue.http.headers.common['Authorization'] = 'Bearer ' + store.state.userStore.token
  }
  // console.log(request)
  next((response) => {
    if (response.status === 401) {
      //  console.log(response.statusText)
    }
    if (response.status === 0) {
      // console.log('Api not Available')
      store.commit(types.SET_API_AVAILABILITY, false)
    } else {
      //  console.log(response)
    }
    // modify response
  })
})
export const HOST_URL = ''
export const API_URL = '/api'


// WEBPACK FOOTER //
// ./resources/js/api/index.js